import React from 'react';
import styled from 'styled-components';
import { callNativeMethod } from 'src/mobile-ecomm/hooks/use-mobile-native-bridge';

type MobileEcommTermsLinkProps = {
  text: string;
  forAccountPage?: boolean;
};

export function MobileEcommTermsLink({ text, forAccountPage }: MobileEcommTermsLinkProps): JSX.Element {
  return (
    <TermsLink
      forAccountPage={forAccountPage}
      type='button'
      onClick={() => callNativeMethod(`onLaunchUrl`, { url: '#' })}
    >
      {text}
    </TermsLink>
  );
}

const TermsLink = styled.button`
  appearance: none;
  border: none;
  background-color: transparent;
  color: ${({ theme, forAccountPage }) =>
    forAccountPage ? theme.colors.grey[30] : theme.customized.colors.buttonsLinks};
  cursor: pointer;
  padding: 0px;

  ${({ forAccountPage }) =>
    forAccountPage &&
    `font-weight: 600;
    text-decoration: underline;
    `}
`;
